import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {get, set, forEach, isEqual, isEmpty, isArray} from "lodash";
import TreeMenuNewList from "./TreeMenuNewList";
import {TreeMenuNewProvider, useTreeMenuNew} from "./TreeMenuNewContext";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";
import useDidMountEffect from "../../utils/useDidMountEffect";
import classnames from "classnames";

export const DISPLAY_TYPE_TREE = 'tree'
export const DISPLAY_TYPE_BREADCRUMB = 'breadcrumb'

const TreeMenuNewWrapper = (props) => {
  const {actives, setActives, displayType, isMulti} = useTreeMenuNew()

  useDidMountEffect(() => {
    if(props.actives.length > 0){
      let actives = {}

      if(isMulti){
        props.actives.forEach(ids => {
          if(isArray(ids) && !isEmpty(ids)){
            set(actives, ids.map(id => `id-${id}`).join('.'), true)
          }
        })
      }else{
        set(actives, props.actives.map(id => `id-${id}`).join('.'), true)
        setActives({...actives})
      }
    }
  })

  useAfterUpdateEffect(() => {
    if(props.actives.length > 0){
      let _actives = {}

      if(isMulti){
        props.actives.forEach(ids => {
          if(isArray(ids) && !isEmpty(ids)){
            set(_actives, ids.map(id => `id-${id}`).join('.'), true)
          }
        })
      }else{
        set(_actives, props.actives.map(id => `id-${id}`).join('.'), true)
      }

      setActives(actives => {
        if(!isEqual(actives, _actives)){
          return {..._actives}
        }

        return actives
      })
    }else{
      if(!isEmpty(actives)){
        setActives({})
      }
    }
  }, [props.actives])

  useAfterUpdateEffect(() => {
    if(props.onCrumbsChanged){
      props.onCrumbsChanged(mapActivesToBreadcrumb(actives))
    }
  }, [actives])

  const mapActivesToBreadcrumb = (actives, ids = []) => {
    forEach(actives, (value, key) => {
      ids.push(key.toString().replace('id-', ''))

      if(value !== true){
        mapActivesToBreadcrumb(value, ids)
      }
    })

    let items = getItems(props.items)
    return ids
      .map(id => {
        const item = items?.find(item => item.id.toString() === id.toString())
        if(!item){
          return false
        }
        items = item.items

        return {
          name: item.breadcrumbPathName || item.label,
          path: item.path,
          onClick: () => {
            setActives(actives => {
              set(actives, item.idsPath.map(id => `id-${id}`).join('.'), true)

              return {...actives}
            })
          }
        }
      })
      .filter(v => !!v)
  }

  const getItems = (items, idsPath = []) => {
    return items.map(item => {
      item.idsPath = [...idsPath, item.id]
      if(get(actives, item.idsPath.map(id => `id-${id}`).join('.'))){
        item.acctive = true
      }else{
        item.acctive = false
      }
      if(item?.items?.length > 0){
        item.items = getItems(item.items, item.idsPath)
      }

      return item
    })
  }

  return <React.Fragment>
    <TreeMenuNewList
      className={classnames({
        'additional-left-padding': displayType === DISPLAY_TYPE_TREE
      })}
      items={getItems(props.items)}
    />
  </React.Fragment>
}

const TreeMenuNew = props => <TreeMenuNewProvider displayType={props.displayType} isMulti={props.displayType === DISPLAY_TYPE_TREE && props.isMulti}>
  <TreeMenuNewWrapper
    {...props}
  />
</TreeMenuNewProvider>;

TreeMenuNew.defaultProps = {
  actives: [],
  displayType: DISPLAY_TYPE_BREADCRUMB,
  isMulti: false,
};

TreeMenuNew.propTypes = {
  isMulti: PropTypes.bool,
  displayType: PropTypes.oneOf([DISPLAY_TYPE_TREE, DISPLAY_TYPE_BREADCRUMB]),
  actives: PropTypes.arrayOf(PropTypes.string,),
  onCrumbsChanged: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    key: PropTypes.string.isRequired,
    label: PropTypes.any.isRequired,
    path: PropTypes.string,
    items: PropTypes.array,
  }).isRequired,).isRequired,
};

export default TreeMenuNew;